import React, { useState, useEffect, useCallback, Suspense } from 'react';

const NavbarPage = React.lazy(() => import('./Navbar'))
const Section = React.lazy(() => import('./section'))
const About = React.lazy(() => import('./About'))
const PrioritasMember = React.lazy(() => import('./PrioritasMember'))
const Benefit = React.lazy(() => import('./PrioritasMember/benefit'))
const TalentMapping = React.lazy(() => import('./TalentMapping'))
const PricingMapping = React.lazy(() => import('./TalentMapping/PricingMapping'))
const Gallery = React.lazy(() => import('./Gallery'))
const Event = React.lazy(() => import('./Event'))
// const FormRegister = React.lazy(() => import('./FormRegister'))
const Footer = React.lazy(() => import('./Footer'))
const Transisi = React.lazy(() => import('./Transisi'))

const Index = () => {
    const [navItems] = useState([
        { id: 1, idnm: "home", navheading: "Home" },
        { id: 2, idnm: "about", navheading: "Prioritas Member" },
        { id: 3, idnm: "talent-mapping", navheading: "Talent Mapping" },
        { id: 4, idnm: "gallery", navheading: "Gallery" },
        { id: 5, idnm: "event", navheading: "Event" },
    ]);
    const [pos] = useState(document.documentElement.scrollTop);
    // eslint-disable-next-line no-unused-vars
    const [imglight, setImglight] = useState(true);
    const [navClass, setNavClass] = useState("");

    const scrollNavigation = useCallback(() => {
        var scrollup = document.documentElement.scrollTop;
        if (scrollup > pos) {
            setNavClass("darkheader");
            setImglight(false);
        } else {
            setNavClass("");
            setImglight(true);
        }
    }, [pos]);

    useEffect(() => {
        window.addEventListener("scroll", scrollNavigation, true);
        return () => {
            window.removeEventListener("scroll", scrollNavigation, true);
        };
    }, [scrollNavigation]);

    const Loader = () => {
        return (
            <div id="preloader">
                <div id="status">
                    <div className="spinner">Loading...</div>
                </div>
            </div>
        );
    }

    return (
        <>
            <Suspense fallback={<Loader />} >
                {/* Importing Navbar */}
                <NavbarPage navItems={navItems} navclassName={navClass} />

                {/* Importing section */}
                <Section />
                <Transisi />

                {/* Importing about */}
                <About />

                {/* Importing about */}
                <PrioritasMember />
                <Transisi />

                <TalentMapping />
                <PricingMapping />

                <Benefit />

                <Gallery />

                <Event />

                {/* Importing Form */}
                {/* <FormRegister/> */}

                {/* Importing footer */}
                <Footer />
            </Suspense>
        </>
    );
}

export default Index;